import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, from } from 'rxjs';

// Services
import * as authentification from '@oel/js-authentification';
import { ConfigMeta, ConfigurationService } from '@oel/js-configuration';
import { mergeMap } from 'rxjs/operators';

@Injectable()
export class Auth0HttpHeadersInterceptor implements HttpInterceptor {
  tokenMockeur = ConfigurationService.getConfig('web-spa-jwt-mockeur');

  constructor() {}
  private readonly EXCLUSIONS = [
    {
      method: 'POST',
      url: '/capacitescalculer'
    }
  ];

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!req.url.includes(ConfigurationService.getConfig(ConfigMeta.OEL_PAAS_API_URL))) {
      return next.handle(req);
    }
    return from(this.addHeaders(req)).pipe(
      mergeMap(reqModifie => {
        return next.handle(reqModifie);
      })
    );
  }

  async addHeaders(req: HttpRequest<unknown>): Promise<HttpRequest<unknown>> {
    const tokenAuth0 = this.tokenMockeur ? this.tokenMockeur : await authentification.getAuthorization();
    const envsoa = ConfigurationService.getConfig('x-desj-envsoa');

    let newHeaders = req.headers;
    let newRequest: HttpRequest<any> = null;

    newHeaders = newHeaders.set('Authorization', `Bearer ${tokenAuth0}`);
    newHeaders = newHeaders.set('x-desj-envsoa', envsoa);

    newRequest = req.clone({
      headers: newHeaders,
      withCredentials: true
    });

    return newRequest;
  }
}
